import Calc from "./components/calc/calc";

function App() {
  return (
    <div className="App">
      <Calc />
    </div>
  );
}

export default App;
